// extracted by mini-css-extract-plugin
export default {"cardContainer":"trigger-card_cardContainer__UMBaQ","text01":"trigger-card_text01__zUDv3","text02":"trigger-card_text02__-pchP"};